import { downloadBonusesApi } from '../model/downloadsBonusesApi';
import { IDownloadBonuses } from '../types';

const getDownloadBonusesApi = downloadBonusesApi.injectEndpoints({
  endpoints: (builder) => ({
    getDownloadsBonuses: builder.mutation<IDownloadBonuses, any>({
      query: ({ upload_type, size, page }) => {
        const sizeParams = size ? `&size=${size}` : '';
        const pageParams = page ? `page=${page}` : '';
        return {
          url: `/promo-b2b/admin/promo-b2b/admin/uploads/${upload_type}?${pageParams}${sizeParams}`,
          method: 'GET',
        };
      },
    }),
  }),
});

export const { useGetDownloadsBonusesMutation } = getDownloadBonusesApi;
